import { ContentTypes, ReferenceReadModel } from '@/client/services/api/graphql/gql/graphql';

// Consumers call bucketReferences() rather than these arrays so the partition rule lives in one place.
const citedContentTypes: ContentTypes[] = [
  ContentTypes.Article,
  ContentTypes.File,
  ContentTypes.Video,
  ContentTypes.Expert,
];
const relatedContentTypes: ContentTypes[] = [
  ContentTypes.Assessment,
  ContentTypes.Event,
  ContentTypes.ImportedContent,
  ContentTypes.Journey,
  ContentTypes.Media,
  ContentTypes.MultiSessionWorkshop,
  ContentTypes.Scorm,
  ContentTypes.Track,
  ContentTypes.Workshop,
];

// References with no contentType, or a type in neither bucket (Poll/Presentation/Quiz/MultiSessionWorkshopSession), are dropped — they have nowhere to render.
export function bucketReferences(refs: ReadonlyArray<ReferenceReadModel>): {
  cited: ReferenceReadModel[];
  related: ReferenceReadModel[];
} {
  return refs.reduce<{ cited: ReferenceReadModel[]; related: ReferenceReadModel[] }>(
    (acc, r) => {
      if (!r?.contentType) return acc;
      if (citedContentTypes.includes(r.contentType)) acc.cited.push(r);
      else if (relatedContentTypes.includes(r.contentType)) acc.related.push(r);
      return acc;
    },
    { cited: [], related: [] },
  );
}
